import { render, staticRenderFns } from "./ReconfigureMailUpdate.vue?vue&type=template&id=5feaaa0c&scoped=true&lang=pug&"
import script from "./ReconfigureMailUpdate.vue?vue&type=script&lang=ts&"
export * from "./ReconfigureMailUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feaaa0c",
  null
  
)

export default component.exports